// Libraries
import styled from "styled-components"


export const VentureProjectDescriptionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 40px;
`

